import React from 'react';
import { expandFontTheme, IconWarning, theme } from '@contrast-security-inc/design-system-foundations';
import { css } from '@emotion/css';
const errorStyles = css `
  ${expandFontTheme(theme.font.metadata)};
  color: ${theme.color.red70};
  display: flex;
  align-items: center;
  min-height: 21px;
  flex-grow: 1;
  align-self: flex-start;

  svg {
    padding-right: 4px;
  }
`;
export const ErrorInput = ({ error, testId, id }) => {
    if (!error) {
        return null;
    }
    return (React.createElement("div", { id: id && `${id}-error`, className: errorStyles, "data-testid": testId && `${testId}-error` },
        React.createElement(IconWarning, { size: "sm", color: "red50", testId: testId && `${testId}-error-icon` }),
        error));
};
